<bic-popup (close)="closed.emit()" [hasBackdrop]="true" customClass="w-[560px]" title="Prüfregeln importieren">
  <div bicPopupContent class="flex flex-col gap-4">
    <div class="flex flex-row items-start gap-2 p-3 bg-blue-50 border border-blue-100 rounded-lg">
      <fa-icon [icon]="faCircleInfo" class="text-blue-500 text-sm mt-0.5"></fa-icon>
      <span class="text-sm text-gray-700">
        Nutze ausschließlich die generierte Vorlage – sie enthält alle Spalten sowie die bestehenden Prüfregeln.
        @if (replaceExisting) {
          Alle bestehenden Prüfregeln dieses Regelsets werden gelöscht und durch die Zeilen der Datei ersetzt.
        } @else {
          Neue Zeilen werden ergänzt, vorhandene Regeln bleiben unverändert.
        }
      </span>
    </div>
    <label class="flex items-center gap-2 cursor-pointer">
      <input [checked]="replaceExisting"
             [disabled]="importing"
             (change)="replaceExistingChange.emit(!replaceExisting)"
             class="w-4 h-4 rounded border-gray-300 text-teal-500 focus:ring-teal-500"
             type="checkbox">
      <span class="text-sm font-medium text-gray-900">
        Alle bestehenden Prüfregeln löschen und durch die Datei ersetzen
      </span>
    </label>
    @if (replaceExisting) {
      <div class="flex flex-row items-start gap-2 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
        <fa-icon [icon]="faCircleInfo" class="text-yellow-700 text-sm mt-0.5"></fa-icon>
        <span class="text-sm text-yellow-900">
          Achtung: Dies löscht unwiderruflich alle bestehenden Prüfregeln dieses Regelsets, auch wenn sie in
          Prüfläufen verwendet werden.
        </span>
      </div>
    }
  </div>

  <div bicPopupButtonGroup class="flex flex-row w-full justify-between items-center gap-4">
    <div class="flex flex-row items-center gap-4">
      <bic-button (onClick)="downloadTemplate.emit()" buttonType="white">
        <fa-icon [icon]="faArrowDownToBracket" iconLeft></fa-icon>
        Vorlage
      </bic-button>
      <input #fileInput (change)="onFileChange($event)" accept=".xlsx" class="hidden" type="file">
      <bic-button (onClick)="triggerFilePicker()" [loading]="importing" buttonType="primary">
        <fa-icon [icon]="faArrowUpFromBracket" iconLeft></fa-icon>
        Importieren
      </bic-button>
    </div>
    <bic-button (onClick)="closed.emit()" buttonType="white">Schließen</bic-button>
  </div>
</bic-popup>
